import { Table } from '@flos/react-ui';
import {
    type MultipleFieldValueInformation,
    type RowInformation
} from '../../config/flavourConfig';
import TableRowValue from '../TableRowValue/TableRowValue';

const TableRowMultipleValues = ({ rowInfo }: { rowInfo: RowInformation }): React.JSX.Element => {
    const fieldValues = rowInfo?.fieldValue as MultipleFieldValueInformation[];
    if (fieldValues.length === 0) {
        return <></>;
    }
    return (
        <Table.Row>
            <Table.Cell className="u-Vtop">
                <p>{rowInfo.name}</p>
            </Table.Cell>
            <Table.Cell align="right">
                {fieldValues?.map((value) => {
                    if (!value.modalInformation) {
                        return (
                            <div key={value.title} className="u-Normalwrap">
                                {value.title}
                            </div>
                        );
                    }
                    return <TableRowValue key={value.title} value={value} />;
                })}
            </Table.Cell>
        </Table.Row>
    );
};

export default TableRowMultipleValues;
